__turbopack_context__.v({
  "carousel-arrow": "styles-module__72CSfq__carousel-arrow",
  "carousel-base": "styles-module__72CSfq__carousel-base",
  "item-container": "styles-module__72CSfq__item-container",
  "item-provider": "styles-module__72CSfq__item-provider",
  "item-tracker": "styles-module__72CSfq__item-tracker",
});
